<template>
  <UnopenedLeadCard @close="close" @open="open" :lead="lead">
    <template #openLabel>
      Add Funds
    </template>
    <div><strong>Yes I want this lead!</strong></div>

    <div class="mt-5">
      Your balance is {{ $formatters.currency(me.balance_cents) }}, but this lead
      will cost {{ $formatters.currency(lead.price_cents) }} <em>(plus tax)</em>.
      You need to add to your balance to claim this lead.
    </div>

    <div class="mt-5">
      Sharing is caring! Most of what we collect goes to the person that created
      this lead.
    </div>

    <div class="mt-5">
      Go now!
    </div>
  </UnopenedLeadCard>
</template>

<script>
import UnopenedLeadCard from './UnopenedLeadCard.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'UnopenedLeadInsufficient',

  components: { UnopenedLeadCard },

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters('auth', ['me']),
  },

  methods: {
    close() {
      this.$emit('close')
    },

    open() {
      this.$router.push( { name: 'billing/add_balance' })
    },
  }
}
</script>